var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advert"},[_c('img',{style:({height:_vm.comObj.height+'px'}),attrs:{"src":_vm.comObj.imgUrl,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }